export class GdsgInventoryReportConfigurationInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceBucketName",
            "baseName": "sourceBucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "metadataFields",
            "baseName": "metadataFields",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "reportFormat",
            "baseName": "reportFormat",
            "type": "GdsgInventoryReportFormat",
            "format": ""
        },
        {
            "name": "csvOptions",
            "baseName": "csvOptions",
            "type": "GdsgInventoryReportCsvOptions",
            "format": ""
        },
        {
            "name": "destinationBucketName",
            "baseName": "destinationBucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "destinationPrefix",
            "baseName": "destinationPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "frequencyOptions",
            "baseName": "frequencyOptions",
            "type": "GdsgInventoryReportFrequencyOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgInventoryReportConfigurationInput.attributeTypeMap;
    }
    constructor() {
    }
}
